// ALL Constants

// const ENV = "prod";

export const CHATBOTCOLLECTION = `discussions`;
export const CONTACTUSCOLLECTION = `contact_us`;
export const WAITLISTCOLLECTION = `waitlist`;
